import type { GameConfig } from "./schema.ts";

/**
 * Product configuration for NANO Magical City.
 *
 * Change the temporary display name here — this is the single source of
 * truth for branding, house metadata, feature flags, and economy seeds.
 * Client UI and the Worker should import from `@nano/game-config`
 * instead of copying these numbers.
 */
export const gameConfigInput = {
  version: 1,
  displayName: "NANO Magical City",
  credit: "Created by nanodev.io.vn",
  flags: {
    leaderboardEnabled: true,
    shopEnabled: true,
    cloudSyncEnabled: true,
  },
  network: {
    maxResultsPerSync: 10,
    syncFlushThreshold: 3,
    leaderboardCacheSeconds: 600,
    leaderboardTopLimit: 50,
    rankScanCap: 5000,
  },
  economy: {
    firstClearGold: {
      base: 20,
      perTenLevels: 5,
    },
    firstThreeStarBonusGold: 5,
    hints: {
      freePerLevel: 2,
      priceGold: 10,
    },
    cosmeticPriceGold: {
      common: { min: 100, max: 200 },
      rare: { min: 250, max: 500 },
      epic: { min: 600, max: 1200 },
    },
    ads: {
      giftGold: 25,
      giftsPerDay: 3,
      hintsPerAd: 1,
    },
  },
  houses: [
    {
      id: "sorting",
      displayName: "Nhà Sắp Xếp",
      description: "Chủ tiệm bừa bộn quá trời! Giúp bác xếp quà, đồ chơi và bánh kẹo vào đúng khay nha.",
      status: "available",
      levelCount: 100,
      contentVersion: "sorting-1.0.0",
      buildingAssetId: "building.sorting",
      entryPosition: { x: 360, y: 720 },
    },
    {
      id: "logic",
      displayName: "Tháp Trí Tuệ",
      description: "Thả bi qua cần lật, đoán xem viên nào lăn về đâu nha.",
      status: "available",
      levelCount: 100,
      contentVersion: "logic-1.0.0",
      buildingAssetId: "building.logic",
      entryPosition: { x: 160, y: 460 },
    },
    {
      id: "tiles",
      displayName: "Lâu Đài Ghép Hình",
      description: "Dạo khắp sảnh ngọc, nhặt gạch vào túi, ba viên giống nhau là thành bùa sáng rinh liền.",
      status: "available",
      levelCount: 100,
      contentVersion: "tiles-1.0.0",
      buildingAssetId: "building.tiles",
      entryPosition: { x: 560, y: 460 },
    },
    {
      id: "arcade",
      displayName: "Nhà Vui Nhộn",
      description: "Máy gắp thú lém lỉnh ở hội chợ, tính khéo từng xu là rinh được thú bông.",
      status: "available",
      levelCount: 100,
      contentVersion: "arcade-1.0.0",
      buildingAssetId: "building.arcade",
      entryPosition: { x: 160, y: 1340 },
    },
    {
      id: "colors",
      displayName: "Phòng Pha Màu",
      description: "Pha màu lung linh rồi rót vào đúng lọ, cẩn thận kẻo lem nha.",
      status: "available",
      levelCount: 100,
      contentVersion: "colors-1.0.0",
      buildingAssetId: "building.colors",
      entryPosition: { x: 560, y: 1340 },
    },
    {
      id: "fill",
      displayName: "Xưởng Phép Thuật",
      description: "Thả cuộn lụa phép gói kín hộp quà, tính khéo để dùng ít cuộn nhất nha.",
      status: "available",
      levelCount: 100,
      contentVersion: "fill-1.0.0",
      buildingAssetId: "building.fill",
      entryPosition: { x: 360, y: 1600 },
    },
  ],
} as const satisfies GameConfig;
